import { render, staticRenderFns } from "./SearchTablePagination.vue?vue&type=template&id=beb10be6&"
import script from "./SearchTablePagination.vue?vue&type=script&lang=js&"
export * from "./SearchTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports